module.exports = __webpack_public_path__ + "static/media/jdl.a1e59cff.png";